import {
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_PLAN_NAME_MAP,
} from "../../constants";

export const subscription = {
  namespaced: true,
  state: {
    subscription: null,
    availablePlan: null,
  },
  mutations: {
    init(state, initialState) {
      if (initialState.subscription && Object.keys(initialState.subscription).length > 0) {
        state.subscription = initialState.subscription;
      }

      if (initialState.availablePlan && Object.keys(initialState.availablePlan).length > 0) {
        state.availablePlan = initialState.availablePlan;
      }

    },
  },
  actions: {
    init(context, initialState) {
      console.debug("Subscription store initialized with:", initialState);
      context.commit("init", initialState);
    },
  },
  getters: {
    subscription: (state) => state.subscription,
    isSubscriptionFree: (state) =>
      state.subscription && state.subscription.provider === "skokka_free",
    isSubscriptionActive: (state) =>
      state.subscription &&
      state.subscription?.status === SUBSCRIPTION_STATUS.ACTIVE,
    isSubscriptionExpired: (state) =>
      state.subscription &&
      state.subscription.status === SUBSCRIPTION_STATUS.EXPIRED,

    availablePlan: (state) => state.availablePlan,
    availablePlanName: (state) =>
      SUBSCRIPTION_PLAN_NAME_MAP[state.availablePlan?.logical_id],
    benefits: (state) => state.availablePlan?.benefits,
  },
};
